import _ from 'lodash'
import { useGetPatientQuery } from './patientQueries.generated'

/** The patient's source (health plan or SELFPAY), which lives in the untyped `details` blob. */
export function usePatientSource(uid: string, { skip = false } = {}) {
  const { data, loading } = useGetPatientQuery({ variables: { uid }, skip })

  return {
    source: _.get(data, ['patients', 0, 'details', 'source']) as string | undefined,
    loading,
  }
}
